import { Component, HostBinding, Input } from '@angular/core';

/**
 * Golden inline hint (`.explanation`) rendered under or beside a control.
 * Replaces the hand-written `<div class="… explanation">{{ key | translate }}</div>`
 * blocks scattered across admin screens.
 *
 * The host element itself carries the global `.explanation` class, so layout
 * classes stay on the tag exactly as they did on the old div:
 *
 *   <app-explanation
 *     class="col-md-12 ml-n3 form-header mb-2"
 *     text="admin.store.catalog.itemTypeMessage"
 *   ></app-explanation>
 *
 * For bodies that are more than a single translated string (links, ngIf spans…)
 * omit `text` and project content instead:
 *
 *   <app-explanation class="w-100">…</app-explanation>
 */
@Component({
  selector: 'app-explanation',
  templateUrl: './explanation.component.html',
  styleUrls: ['./explanation.component.scss'],
})
export class ExplanationComponent {
  /** Translation key for the hint text. Empty → projected content only. */
  @Input() text = '';

  /** The host IS the `.explanation` element — global styling applies to it directly. */
  @HostBinding('class.explanation')
  readonly explanationClass = true;
}
